import { Routes } from '@angular/router';
import { RosterPage, TacticPage, NationalTacticPage } from '../pages';
import { SecurityGuard } from '../services';
import { PlayersPage } from 'app/pages/players-page';


export const PRIVATE_ROUTES: Routes = [
  { 
    path: 'tactic',
    component: TacticPage,
    canActivate: [SecurityGuard],
    data: { }
  },
  { 
    path: 'roster',
    component: RosterPage,
    canActivate: [SecurityGuard],
    data: { }
  },
  { 
    path: 'national/tactic',
    component: NationalTacticPage,
    canActivate: [SecurityGuard],
    data: { }
  },
  { 
    path: 'players',
    component: PlayersPage,
    canActivate: [SecurityGuard],
    data: { }
  },
];